if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

// document.addEventListener('click', function(e) {
//   const target = e.target.closest('.product-sec1 .jdgm-widget');
//   if (!target) return;

//   e.preventDefault();

//   const reviews = document.querySelector('#product-reviews');
//   if (reviews) {
//     reviews.scrollIntoView({ behavior: 'smooth' });
//   }
// });

function openAllShopifyFilters() {
  document.querySelectorAll('.accordion-details:not(.product__blocks .accordion-details)').forEach(d => {
    // Force <details> open
    d.setAttribute('open', '');

    // Make sure aria-expanded matches
    d.setAttribute('aria-expanded', 'true');
  });
}

// On initial load
document.addEventListener('DOMContentLoaded', openAllShopifyFilters);

// When Shopify AJAX reloads filter sections
document.addEventListener('shopify:section:load', openAllShopifyFilters);
document.addEventListener('shopify:filters:updated', openAllShopifyFilters);